
import React from 'react';
import { Button } from '@/components/ui/button';
import { List, Save, RotateCcw } from 'lucide-react';
import { 
  Select, 
  SelectContent, 
  SelectGroup, 
  SelectItem, 
  SelectLabel, 
  SelectTrigger, 
  SelectValue 
} from '@/components/ui/select';

interface AIReportingChatActionsProps {
  showTemplates: boolean;
  setShowTemplates: (val: boolean) => void;
  handleSaveReport: () => void;
  resetConversation: () => void;
  selectedCategory: string;
  setSelectedCategory: (cat: string) => void;
  reportCategories: string[];
}

export const AIReportingChatActions: React.FC<AIReportingChatActionsProps> = ({
  showTemplates,
  setShowTemplates,
  handleSaveReport,
  resetConversation,
  selectedCategory,
  setSelectedCategory,
  reportCategories
}) => {
  return (
    <div className="flex justify-between items-center mb-4">
      <div className="flex space-x-2">
        <Button 
          variant="outline" 
          size="sm" 
          onClick={() => setShowTemplates(!showTemplates)}
        >
          <List className="h-4 w-4 mr-2" />
          {showTemplates ? 'Hide Templates' : 'Show Templates'}
        </Button>
        
        <Button 
          variant="outline" 
          size="sm" 
          onClick={handleSaveReport}
        >
          <Save className="h-4 w-4 mr-2" />
          Save Report
        </Button>
        
        <Button 
          variant="outline" 
          size="sm" 
          onClick={resetConversation}
        >
          <RotateCcw className="h-4 w-4 mr-2" />
          New Report
        </Button>
      </div>
      
      {showTemplates && (
        <Select 
          value={selectedCategory} 
          onValueChange={setSelectedCategory}
        >
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder="Select category" />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              <SelectLabel>Categories</SelectLabel>
              {reportCategories.map(category => (
                <SelectItem key={category} value={category}>{category}</SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
      )}
    </div>
  );
};
